import React from 'react'
import styles from './ScrollRef.module.sass'

interface Props {
  id: string
  position?: '' | 'absolute'
  className?: string
  refClassName?: string
}

const ScrollRef = (props: Props) => {
  const { id = undefined, position = '', className = '', refClassName = '' } = props

  return id ? (
    <div className={`${styles.root} ${position ? styles[`root--${position}`] : ''} ${className}`}>
      <div id={id} className={`${styles.ref} ${refClassName}`} />
    </div>
  ) : (
    <></>
  )
}

export default ScrollRef
